import React from 'react'
import {Outlet} from "react-router-dom"
import Header from './Header'
import Footer from './Footer'

export default function Main({ cart, setCart, handleChange, categories }) {

    console.log('render main');

    return (
        <>
            <Header cart={cart} categories={categories} setCart={setCart} handleChange={handleChange}/>
            <Outlet />
            <Footer/>
        </>
    )
}